// @flow
//eslint-disable-next-line

import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Card } from 'react-bootstrap'

import { MenuWrapper } from '../../../../../../containers'
import { cartActions } from '../../../../../../store/actions'

const MobileMenuDropdown = () => {
	const { showCartMenu } = useSelector((state) => state.action)
	const { count } = useSelector((state) => state.cart.cart_items)
	const dispatch = useDispatch()

	const accordianToggle = () => {
		dispatch(cartActions.TOGGLE_CART_ICON())
	}

	return (
		<div className={`cartMenu cartSlideWrapper ${showCartMenu && count === 0 ? 'd-none' : ''}`}>
			<div className="accordion">
				<Card>
					<div className={showCartMenu ? 'show' : 'collapse'}>
						<Card.Body>
							<MenuWrapper />
						</Card.Body>
					</div>
					<div className={`closeSlideCart ${!showCartMenu ? 'd-none' : ''}`}>
						<button onClick={accordianToggle}>
							<i className="icon-icon-caret-down"></i>
						</button>
					</div>
				</Card>
			</div>
		</div>
	)
}

export default MobileMenuDropdown
